(function () {
  const sentEvents = new Set();

  function gtagReady() {
    return typeof window.gtag === 'function';
  }

  function toNumber(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function centsToValue(cents) {
    return Math.round(toNumber(cents)) / 100;
  }

  function compactItem(item) {
    return {
      item_id: String(item.item_id || item.variant_id || item.id || ''),
      item_name: item.item_name || item.product_title || item.title || '',
      item_brand: item.item_brand || item.vendor || 'Fukuoka Silk',
      item_category: item.item_category || item.product_type || '',
      item_variant: item.item_variant || item.variant_title || '',
      price: toNumber(item.price),
      quantity: toNumber(item.quantity || 1) || 1,
    };
  }

  function eventId(prefix) {
    return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }

  function sendEvent(name, payload, dedupeKey) {
    if (!gtagReady()) return;
    if (dedupeKey && sentEvents.has(dedupeKey)) return;
    if (dedupeKey) sentEvents.add(dedupeKey);

    window.gtag('event', name, {
      send_source: 'fukuoka_silk_theme',
      ...payload,
    });
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 120);
  }

  function linkPath(link) {
    try {
      return new URL(link.href, window.location.href).pathname;
    } catch {
      return link.getAttribute('href') || '';
    }
  }

  function trackEntryClick(link) {
    if (!link) return;

    const entryTheme = cleanText(link.dataset.fsTheme);
    const entryLabel = cleanText(link.dataset.fsLabel || link.textContent);

    sendEvent('fs_entry_click', {
      content_type: 'site_entry',
      content_group: entryTheme,
      item_id: entryLabel,
      entry_area: cleanText(link.dataset.fsEntry),
      entry_theme: entryTheme,
      entry_position: cleanText(link.dataset.fsPosition),
      link_text: cleanText(link.textContent),
      link_url: link.href || '',
      link_path: linkPath(link),
      page_path: window.location.pathname,
    });
  }

  function pinterestLineItem(item) {
    return {
      product_id: item.item_id,
      product_name: item.item_name,
      product_category: item.item_category,
      product_variant_id: item.item_id,
      product_variant: item.item_variant,
      product_price: item.price,
      product_quantity: item.quantity,
      product_brand: item.item_brand,
    };
  }

  function sendPinterestEvent(eventName, payload, dedupeKey) {
    window.FukuokaSilkPinterest?.track?.(eventName, payload, dedupeKey);
  }

  function refreshCurrentCart() {
    if (!window.routes?.cart_url || typeof window.fetch !== 'function') {
      return Promise.resolve(null);
    }

    return fetch(`${window.routes.cart_url}.js`, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart) window.FukuokaSilkCart = cart;
        return cart;
      })
      .catch(() => null);
  }

  function pinterestPayload(prefix, currency, value, items) {
    return {
      event_id: eventId(prefix),
      currency,
      value,
      order_quantity: items.reduce((total, item) => total + item.quantity, 0),
      line_items: items.map(pinterestLineItem),
    };
  }

  function itemFromCartLine(line) {
    return compactItem({
      item_id: line.variant_id || line.id,
      item_name: line.product_title || line.title,
      item_brand: line.vendor,
      item_category: line.product_type,
      item_variant: line.variant_title,
      price: centsToValue(line.final_price ?? line.price),
      quantity: line.quantity,
    });
  }

  function trackViewItem(product) {
    if (!product || !product.item) return;
    const item = compactItem(product.item);
    sendEvent(
      'view_item',
      {
        currency: product.currency || window.Shopify?.currency?.active || 'USD',
        value: item.price,
        items: [item],
      },
      `view_item:${item.item_id}:${window.location.pathname}`
    );
  }

  function trackAddToCart(lineItem, formData) {
    if (!lineItem) return;
    const quantity = toNumber(formData?.get('quantity') || lineItem.quantity || 1) || 1;
    const item = itemFromCartLine({ ...lineItem, quantity });
    const currency = window.Shopify?.currency?.active || 'USD';
    const value = item.price * item.quantity;

    sendEvent('add_to_cart', {
      currency,
      value,
      items: [item],
    });
    sendPinterestEvent('addtocart', pinterestPayload('addtocart', currency, value, [item]));
    refreshCurrentCart();
  }

  function trackViewCart(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;
    const items = cart.items.map(itemFromCartLine);
    sendEvent(
      'view_cart',
      {
        currency: cart.currency || window.Shopify?.currency?.active || 'USD',
        value: centsToValue(cart.total_price),
        items,
      },
      `view_cart:${cart.token || window.location.pathname}:${cart.item_count}:${cart.total_price}`
    );
  }

  function trackBeginCheckout(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;
    const items = cart.items.map(itemFromCartLine);
    const currency = cart.currency || window.Shopify?.currency?.active || 'USD';
    const value = centsToValue(cart.total_price);
    const dedupeKey = `begin_checkout:${cart.token || ''}:${cart.item_count || items.length}:${cart.total_price || value}`;

    sendEvent('begin_checkout', {
      currency,
      value,
      items,
    }, dedupeKey);
    sendPinterestEvent('initiatecheckout', pinterestPayload('initiatecheckout', currency, value, items), dedupeKey);
  }

  function trackBeginCheckoutFromCurrentCart() {
    if (window.FukuokaSilkCart?.items?.length) {
      trackBeginCheckout(window.FukuokaSilkCart);
      return Promise.resolve();
    }

    if (!window.routes?.cart_url || typeof window.fetch !== 'function') {
      return Promise.resolve();
    }

    return refreshCurrentCart().then((cart) => {
      if (cart) trackBeginCheckout(cart);
    });
  }

  function isCheckoutTrigger(element) {
    return Boolean(element?.closest?.('button[name="checkout"], input[name="checkout"], [data-fs-track-checkout]'));
  }

  function installCheckoutIntentTracking() {
    const handler = (event) => {
      if (isCheckoutTrigger(event.target)) {
        trackBeginCheckoutFromCurrentCart();
      }
    };

    document.addEventListener('pointerdown', handler, { capture: true });
    document.addEventListener('click', handler, { capture: true });
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form?.querySelector?.('[name="checkout"], [data-fs-track-checkout]')) return;

      if (
        form.matches?.('[data-fs-delay-checkout-tracking]') &&
        !form.dataset.fsCheckoutTrackingSubmitted &&
        event.cancelable
      ) {
        event.preventDefault();
        form.dataset.fsCheckoutTrackingSubmitted = 'true';

        const submitter = event.submitter || form.querySelector('[name="checkout"], [data-fs-track-checkout]');
        Promise.race([
          trackBeginCheckoutFromCurrentCart(),
          new Promise((resolve) => setTimeout(resolve, 450)),
        ]).finally(() => {
          if (typeof form.requestSubmit === 'function' && submitter) {
            form.requestSubmit(submitter);
          } else {
            if (!form.querySelector('input[name="checkout"]')) {
              const checkoutInput = document.createElement('input');
              checkoutInput.type = 'hidden';
              checkoutInput.name = 'checkout';
              checkoutInput.value = submitter?.value || '';
              form.appendChild(checkoutInput);
            }
            form.submit();
          }
        });
        return;
      }

      trackBeginCheckoutFromCurrentCart();
    }, { capture: true });
  }

  function installEntryClickTracking() {
    document.addEventListener('click', (event) => {
      const link = event.target?.closest?.('a[data-fs-entry]');
      if (!link) return;

      trackEntryClick(link);
    }, { capture: true });
  }

  window.FukuokaSilkEcommerce = {
    sendEvent,
    trackViewItem,
    trackAddToCart,
    trackViewCart,
    trackBeginCheckout,
    trackBeginCheckoutFromCurrentCart,
    refreshCurrentCart,
    trackEntryClick,
  };

  installCheckoutIntentTracking();
  installEntryClickTracking();
})();
